// 前台路由页面配置
import Backstage from "@/views/front/main/index.vue";
// import mainVideoView from "@/views/front/mainVideoView/index.vue";
export const FrontpageRouter = [
  {
    path: "/",
    name: "backfont",
    component: Backstage,
    redirect: "/Evaluate",
    children: [
      {
        // 例子(组件 / 公共样式dom结构)
        path: "/example",
        name: "example",
        component: () => import("@/views/front/example.vue"),
        meta: {
          affiliation_Left: "example", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },

      // --------------------------
      {
        // 督导反馈
        path: "/teacherFeedback",
        name: "teacherFeedback",
        component: () => import("../../views/front/teacherFeedback/index.vue"),
        meta: {
          affiliation_Left: "teacherFeedback", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      {
        //反馈详情
        path: "/feedbackDetails",
        name: "feedbackDetails",
        component: () =>
          import("../../views/front/teacherFeedback/feedbackDetails/index.vue"),
        meta: {
          affiliation_Left: "teacherFeedback", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      {
        // 督导反馈 -- 详情 -- 问卷详情
        path: "/feeQuestionnaire",
        name: "feeQuestionnaire",
        component: () =>
          import("@/views/front/teacherFeedback/feeQuestionnaire"),
        meta: {
          affiliation_Left: "teacherFeedback", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      {
        // 被评记录
        path: "/Evaluate",
        name: "frontEvaluate",
        component: () => import("@/views/front/teacher/evaluateList"),
        meta: {
          affiliation_Left: "frontEvaluate", // 归属级 (左侧的)
          keepAlive: false
        },
      },
      {
        // 被评记录 -- 申诉
        path: "/Evaluate/Appeal",
        name: "Appeal",
        component: () => import("@/views/front/teacher/evaluateList/add.vue"),
        meta: {
          affiliation_Left: "frontEvaluate", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      {
        // 被评报告
        path: "/Report",
        name: "frontReport",
        component: () => import("@/views/front/teacher/evaluateReport"),
        meta: {
          affiliation_Left: "frontReport", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      {
        // 我的申诉
        path: "/MeAppeal",
        name: "frontappeal",
        component: () => import("@/views/front/teacher/appeal"),
        meta: {
          affiliation_Left: "frontappeal", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      {
        // 我的教案
        path: "/lessonPlan",
        name: "lessonPlan",
        component: () => import("@/views/front/teacher/lessonPlan"),
        meta: {
          affiliation_Left: "lessonPlan", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
          // keepAlive: true
        },
      },
      // --------------------------
      {
        // 教案管理
        path: "/lessonPlanManagement",
        name: "lessonPlanManagement",
        component: () => import("@/views/front/lessonPlanManagement/Management"),
        meta: {
          affiliation_Left: "lessonPlanManagement", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
          // keepAlive: false
        },
      },
      {
        // 教案评价
        path: "/lessonPlanEvaluation",
        name: "lessonPlanEvaluation",
        component: () => import("@/views/front/lessonPlanManagement/evaluation"),
        meta: {
          affiliation_Left: "lessonPlanEvaluation", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
          // keepAlive: false
        },
      },
      {
        // 教案统计
        path: "/lessonPlanStatistics",
        name: "lessonPlanStatistics",
        component: () => import("@/views/front/lessonPlanManagement/Statistics"),
        meta: {
          affiliation_Left: "lessonPlanStatistics", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
          // keepAlive: false
        },
      },
      // --------------------------
      {
        // 我的申诉-详情 / 督导申诉反馈-详情
        path: "/Appeal/Detail",
        name: "AppealDetail",
        component: () => import("@/views/front/teacher/appeal/detail.vue"),
        meta: {
          affiliation_Left: "", // teacherFeedback归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // --------------------------

      // {
      //   // 听课评课
      //   path: "/TeachingStudy",
      //   name: "TeachingStudy",
      //   component: () => import("@/views/front/supervisor/Teaching"),
      //   meta: {
      //     affiliation_Left: "TeachingStudy", // 归属级 (左侧的)
      //   },
      // },
      {
        // 评课计划
        path: "/LessonEvaluationPlan",
        name: "LessonEvaluationPlan",
        component: () => import("@/views/front/supervisor/Teaching/plan.vue"),
        meta: {
          affiliation_Left: "LessonEvaluationPlan", // 归属级 (左侧的)
          keepAlive: true,// 页面缓存
        },
      },
      {
        // 评课记录
        path: "/LessonEvaluationRecord",
        name: "LessonEvaluationRecord",
        component: () => import("@/views/front/supervisor/Teaching/record.vue"),
        meta: {
          affiliation_Left: "LessonEvaluationRecord", // 归属级 (左侧的)
          keepAlive: true,
        },
      },
      {
        // 邀请我听
        path: "/InviteMeToListen",
        name: "InviteMeToListen",
        component: () => import("@/views/front/supervisor/Teaching/invite.vue"),
        meta: {
          affiliation_Left: "InviteMeToListen", // 归属级 (左侧的)
          keepAlive: true,// 页面缓存
        },
      },
      {
        // 临时评课
        path: "/TemporaryCourseEvaluation",
        name: "TemporaryCourseEvaluation",
        component: () => import("@/views/front/supervisor/Teaching/temporary.vue"),
        meta: {
          affiliation_Left: "TemporaryCourseEvaluation", // 归属级 (左侧的)
          keepAlive: true,// 页面缓存
        },
      },
      {
        // 听课评课记录详情
        path: "/TeachingRecordDetail",
        name: "TeachingRecordDetail",
        component: () =>
          import("@/views/front/supervisor/Teaching/recordDetail"),
        meta: {
          affiliation_Left: "TeachingStudy", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      {
        // 自由听课
        path: "/FreeCourse",
        name: "FreeCourse",
        component: () => import("@/views/front/supervisor/FreeCourse"),
        meta: {
          affiliation_Left: "FreeCourse", // 归属级 (左侧的)
          keepAlive: true,
        },
      },
      {
        // 实时巡课
        path: "/SCADA",
        name: "SCADA",
        component: () => import("@/views/front/supervisor/SCADA"),
        meta: {
          affiliation_Left: "SCADA", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      {
        // 实时巡课  详情页
        path: "/SCADA/Detail",
        name: "SCADA_Detail",
        component: () => import("@/views/front/supervisor/SCADA/detailVideo"),
        meta: {
          affiliation_Left: "SCADA", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      {
        // 评价问卷
        path: "/EvaluationQuestionnaire",
        name: "EvaluationQuestionnaire",
        component: () =>
          import("@/views/front/supervisor/EvaluationQuestionnaire"),
        meta: {
          affiliation_Left: "EvaluationQuestionnaire", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      {
        // 评课报告
        path: "/CourseEvaluationReport",
        name: "CourseEvaluationReport",
        component: () =>
          import("@/views/front/supervisor/CourseEvaluationReport"),
        meta: {
          affiliation_Left: "CourseEvaluationReport", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // --------------------------

      {
        // 教室使用情况
        path: "/ClassroomUsageSituation",
        name: "ClassroomUsageSituation",
        component: () => import("@/views/front/ClassroomUsageSituation"),
        meta: {
          affiliation_Left: "ClassroomUsageSituation", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // --------------------------
      {
        // 消息中心
        path: "/MeInfo",
        name: "frontMeInfo",
        component: () => import("@/views/front/info"),
        meta: {
          affiliation_Left: "frontMeInfo", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      {
        // 组织架构管理
        path: "/back/ZZJGtrre",
        name: "ZZJGtrre",
        component: () => import("../../views/back/organizationChart/index.vue"),
        meta: {
          affiliation_Left: "ZZJGtrre", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      {
        // 用户管理
        path: "/back/rolePermission",
        name: "rolePermission",
        component: () => import("../../views/back/rolePermission/index.vue"),
        meta: {
          affiliation_Left: "rolePermission", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      {
        // 角色管理
        path: "/back/roleManagement",
        name: "roleManagement",
        component: () => import("../../views/back/roleManagement/index.vue"),
        meta: {
          affiliation_Left: "roleManagement", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      {
        // 巡课录制管理
        path: "/back/transcribeManagement",
        name: "transcribeManagement",
        component: () =>
          import("../../views/back/transcribeManagement/index.vue"),
        meta: {
          affiliation_Left: "transcribeManagement", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      {
        // 督导组管理
        path: "/back/SupervisionGroupManagement",
        name: "supervisionGroupManagement",
        component: () =>
          import("../../views/back/SupervisionGroupManagement/index.vue"),
        meta: {
          affiliation_Left: "supervisionGroupManagement", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      {
        // 添加督导组
        path: "/back/AddSGMan",
        name: "AddSGMan",
        component: () =>
          import(
            "../../views/back/SupervisionGroupManagement/AddSGMan/index.vue"
          ),
        meta: {
          affiliation_Left: "supervisionGroupManagement", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      {
        // 督导组名单
        path: "/back/SteeringList",
        name: "SteeringList",
        component: () =>
          import(
            "../../views/back/SupervisionGroupManagement/SteeringList/index.vue"
          ),
        meta: {
          affiliation_Left: "SteeringList", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      {
        // 教师菜单 我的课表  教室
        path: "/back/scheduleManage",
        name: "scheduleManage",
        component: () => import("../../views/back/scheduleManage/index.vue"),
        meta: {
          affiliation_Left: "scheduleManage", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      {
        // 全局设置
        path: "/back/GlobalSettings",
        name: "GlobalSettings",
        component: () => import("../../views/back/GlobalSettings/index.vue"),
        meta: {
          affiliation_Left: "GlobalSettings", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      {
        // AI预警设置
        path: "/back/aiWarningSettings",
        name: "aiWarningSettings",
        component: () => import("../../views/back/aiWarningSettings/index.vue"),
        meta: {
          affiliation_Left: "aiWarningSettings", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      {
        // AI预警设置
        path: "/back/frontRowSettings",
        name: "frontRowSettings",
        component: () => import("../../views/back/frontRowSettings/index.vue"),
        meta: {
          affiliation_Left: "frontRowSettings", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      /* 评价管理-Evaluation */
      // 指标分类
      {
        path: "/back/indexClassification",
        name: "indexClassification",
        component: () =>
          import("../../views/back/Evaluation/IndexClassification/index.vue"),
        meta: {
          affiliation_Left: "indexClassification", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // 问卷分类
      {
        path: "/back/questionClassification",
        name: "questionClassification",
        component: () =>
          import(
            "../../views/back/Evaluation/QuestionClassification/index.vue"
          ),
        meta: {
          affiliation_Left: "questionClassification", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // 指标管理
      {
        path: "/back/indexManagement",
        name: "indexManagement",
        component: () =>
          import("../../views/back/Evaluation/IndexManagement/index.vue"),
        meta: {
          affiliation_Left: "indexManagement", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // 指标管理
      {
        path: "/back/indexAddManagement",
        name: "indexAddManagement",
        component: () =>
          import(
            "../../views/back/Evaluation/IndexManagement/AddIndex/index.vue"
          ),
        meta: {
          affiliation_Left: "indexAddManagement", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // 问卷管理/发放
      {
        path: "/back/questionManagement",
        name: "questionManagement",
        component: () =>
          import("../../views/back/Evaluation/QuestionManagement/index.vue"),
        meta: {
          affiliation_Left: "questionManagement", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // 问卷管理/发放-编辑问卷
      {
        path: "/back/questionManagementSet",
        name: "questionManagementSet",
        component: () =>
          import(
            "../../views/back/Evaluation/QuestionManagement/SetQuestion.vue"
          ),
      },
      // 问卷管理/发放-发布问卷
      {
        path: "/back/questionManagementPass",
        name: "questionManagementPass",
        component: () =>
          import(
            "../../views/back/Evaluation/QuestionManagement/PassQuestion.vue"
          ),
        meta: {
          affiliation_Left: "questionManagementPass", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // 已发布问卷管理
      {
        path: "/back/readQuestions",
        name: "readQuestions",
        component: () =>
          import("../../views/back/Evaluation/ReadQuestions/index.vue"),
        meta: {
          affiliation_Left: "readQuestions", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // 已发布问卷管理-详情
      {
        path: "/back/readQuestionsDetail",
        name: "readQuestionsDetail",
        component: () =>
          import("../../views/back/Evaluation/ReadQuestions/Detail.vue"),
      },
      /* 指派督导听课任务-Assignments */
      // 督导任务
      {
        path: "/back/assignmentsTask",
        name: "assignmentsTask",
        component: () => import("../../views/back/Assignments/Task/index.vue"),
        meta: {
          affiliation_Left: "assignmentsTask", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      // 按教师分配权限
      {
        path: "/back/assignmentsTeacher",
        name: "assignmentsTeacher",
        component: () =>
          import("../../views/back/Assignments/Teacher/index.vue"),
        meta: {
          affiliation_Left: "assignmentsTeacher", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      // 按课程分配权限
      {
        path: "/back/assignmentsCourse",
        name: "assignmentsCourse",
        component: () =>
          import("../../views/back/Assignments/Course/index.vue"),
        meta: {
          affiliation_Left: "assignmentsCourse", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      // 按节次指派
      {
        path: "/back/assignmentsSection",
        name: "assignmentsSection",
        component: () =>
          import("../../views/back/Assignments/Section/index.vue"),
        meta: {
          affiliation_Left: "assignmentsSection", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // 指派节次
      {
        path: "/back/assignmentsPoint",
        name: "assignmentsPoint",
        component: () =>
          import("../../views/back/Assignments/Section/Point.vue"),
        meta: {
          affiliation_Left: "assignmentsSection", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // 督导进度详情
      {
        path: "/back/assignmentsProgress",
        name: "assignmentsProgress",
        component: () =>
          import("../../views/back/Assignments/Section/Progress.vue"),
        meta: {
          affiliation_Left: "assignmentsSection", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // 查看问卷
      {
        path: "/back/assignmentsQuestionnaire",
        name: "assignmentsQuestionnaire",
        component: () =>
          import("../../views/back/Assignments/Section/questionnaire.vue"),
        meta: {
          affiliation_Left: "assignmentsSection", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // 评价模板
      {
        path: "/back/evaluationTemplate",
        name: "evaluationTemplate",
        component: () =>
          import("../../views/back/EvaluationTemplate/index.vue"),
        meta: {
          affiliation_Left: "evaluationTemplate", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      // 督导计划
      {
        path: "/back/supervisionScheme",
        name: "supervisionScheme",
        component: () => import("../../views/back/SupervisionScheme/index.vue"),
        meta: {
          affiliation_Left: "supervisionScheme", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      // 督导计划-新增
      {
        path: "/back/supervisionSchemeAddPlan",
        name: "supervisionSchemeAddPlan",
        component: () =>
          import("../../views/back/SupervisionScheme/AddPlan.vue"),
        meta: {
          affiliation_Left: "supervisionScheme", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // 督导计划-详情
      {
        path: "/back/supervisionSchemeDetail",
        name: "supervisionSchemeDetail",
        component: () =>
          import("../../views/back/SupervisionScheme/Detail.vue"),
        meta: {
          affiliation_Left: "supervisionScheme", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // 计划进度
      {
        path: "/back/targetAdvance",
        name: "targetAdvance",
        component: () => import("../../views/back/TargetAdvance/index.vue"),
        meta: {
          affiliation_Left: "targetAdvance", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      // 计划进度-详情
      {
        path: "/back/targetAdvanceDetail",
        name: "targetAdvanceDetail",
        component: () =>
          import("../../views/back/TargetAdvance/Detail.vue"),
        meta: {
          affiliation_Left: "targetAdvance", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      {
        // 课堂评价统计-评价详情
        path: "/back/evaluateStatisticsDetailss",
        name: "evaluateStatisticsDetailss",
        component: () =>
          import("../../views/back/evaluateStatistics/details/index.vue"),
        meta: {
          affiliation_Left: "targetAdvance", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // 数据统计
      {
        // 课堂三率统计
        path: "/back/threeRateStatistics",
        name: "threeRateStatistics",
        component: () =>
          import("../../views/back/threeRateStatistics/index.vue"),
        meta: {
          affiliation_Left: "threeRateStatistics", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      {
        // 课堂三率详情
        path: "/back/threeRateStatisticsDetails",
        name: "threeRateStatisticsDetails",
        component: () =>
          import("../../views/back/threeRateStatistics/details/index.vue"),
        meta: {
          affiliation_Left: "threeRateStatistics", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      {
        // 课堂评价统计
        path: "/back/evaluateStatistics",
        name: "evaluateStatistics",
        component: () =>
          import("../../views/back/evaluateStatistics/index.vue"),
        meta: {
          affiliation_Left: "evaluateStatistics", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      {
        // 课堂评价统计
        path: "/back/evaluateStatisticsDetails",
        name: "evaluateStatisticsDetails",
        component: () =>
          import("../../views/back/evaluateStatistics/details/index.vue"),
        meta: {
          affiliation_Left: "evaluateStatistics", // 归属级 (左侧的)
        },
        beforeEnter: (to, from, next) => {
          to.meta.affiliation_Left = from.meta.affiliation_Left;
          next();
        },
      },
      {
        // 敏感话题课堂
        path: "/back/sensitiveTopic",
        name: "sensitiveTopic",
        component: () => import("../../views/back/sensitiveTopic/index.vue"),
        meta: {
          affiliation_Left: "sensitiveTopic", // 归属级 (左侧的)
          keepAlive: true
        },
      },
      {
        // 敏感话题课堂详情
        path: "/back/sensitiveTopicDetails",
        name: "sensitiveTopicDetails",
        component: () =>
          import("../../views/back/sensitiveTopic/details/index.vue"),
        meta: {
          affiliation_Left: "sensitiveTopic", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // 直播管理（昔阳县需求）
      {
        path: "/back/LiveManagement",
        name: "LiveManagement",
        component: () =>
          import("../../views/back/LiveManagement/index.vue"),
        meta: {
          affiliation_Left: "LiveManagement", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
      // 直播管理-新建直播
      {
        path: "/back/LiveManagementAdd",
        name: "LiveManagementAdd",
        component: () =>
          import("../../views/back/LiveManagement/LiveAdd.vue"),
        meta: {
          affiliation_Left: "LiveManagement", // 归属级 (左侧的)
          keepAlive: false,// 页面缓存
        },
      },
    ],
  },
  //单点登录
  {
    path: "/SSO",
    name: "SSO",
    component: () => import("@/views/wx-SSO")
  },
  //单点登录
  {
    path: "/SSOBS",
    name: "SSOBS",
    component: () => import("@/views/wx-SSO")
  },
  // {
  //   // 直播详情页面
  //   path: "/SCADA",
  //   name: "VideoDetail",
  //   component: mainVideoView,
  //   meta: {
  //     affiliation_Left: "SCADA", // 归属级 (左侧的)
  //   },
  //   children: [
  //     {
  //       path: "/SCADA/Detail",
  //       name: "SCADA_Detail",
  //       component: () => import("@/views/front/supervisor/SCADA/detailVideo"),
  //       meta: {
  //         affiliation_Left: "SCADA", // 归属级 (左侧的)
  //       },
  //     },
  //   ],
  // },
  // 评课报告
  {
    path: "/back/assignmentsEchartsTeport",
    name: "assignmentsEchartsTeport",
    component: () =>
      import("../../views/back/Assignments/Section/EchartsTeport.vue"),
    meta: {
      mark: "homedatacrx",

      affiliation_Left: "dataAnalysisReport", // 归属级 (左侧的)
      keepAlive: false,// 页面缓存
    },
  },
  {
    // 数据分析报告
    path: "/wenxiang/dataAnalysisReport",
    name: "dataAnalysisReport",
    component: () => import("../../views/front/dataAnalysisReport/index.vue"),
    meta: {
      mark: "homedatacrx",

      affiliation_Left: "dataAnalysisReport", // 归属级 (左侧的)
      keepAlive: false,// 页面缓存
    },
  },
  // 新建模板
  {
    path: "/back/evaluationAddTemplate",
    name: "evaluationAddTemplate",
    component: () =>
      import("../../views/back/EvaluationTemplate/AddTemplate.vue"),
  },
  // 添加题目
  {
    path: "/back/evaluationAddQuestions",
    name: "evaluationAddQuestions",
    component: () =>
      import("../../views/back/EvaluationTemplate/AddQuestions.vue"),
  },
  // 模板详情
  {
    path: "/back/evaluationDetail",
    name: "evaluationDetail",
    component: () =>
      import("../../views/back/EvaluationTemplate/Detail.vue"),
  },
  // 直播列表
  {
    path: "/back/liveListPage",
    name: "liveListPage",
    component: () =>
      import("../../views/back/Live/index.vue"),
  },
  // 直播详情页
  {
    path: "/back/liveListDetail",
    name: "liveListDetail",
    component: () =>
      import("../../views/back/Live/Detail.vue"),
  },
];
